<template>
  <div class="container-line">
    <hr :class="classLine">
  </div>
</template>

<script>
  export default {
    props: {
      status: null
    },
    computed: {
      classLine() {
        if (this.status == 'finished') {
          return 'continuous-line'
        }
        if (this.status == 'in_progress') {
          return 'dotted-line'
        }        
      }
    }
  }
</script>

<style scoped>

</style>
